/**
 * @author: Wangwei
 * @description: 阅卷
 */
import { useRequest } from 'umi';
import React, { useState, useEffect } from 'react';
import { Tabs, Input, Button } from 'antd';
import NeedLogin from '@/components/isLogin';
import MarkingTable from './components/markingTable';
import { getAuth } from '@/utils/requests/camp/requests_marking';
import NoAuth from '@/pages/camp/components/noAuth';

export default function Marking() {
  const [markingNum, setMarkingNum] = useState(0);
  const [auth, setAuth] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);

  // 鉴权
  const { run: getAuthRequest } = useRequest(
    () => {
      return getAuth();
    },
    {
      manual: true,
      onSuccess: (res) => {
        setLoading(true);
      },
      onError: (error: any) => {
        const { request, response, data } = error;
        if (response.status === 403) {
          setAuth(false);
        }
      },
    },
  );
  useEffect(() => {
    getAuthRequest();
  }, []);

  return (
    <>
      <NeedLogin />
      {!auth && <NoAuth />}
      {loading && (
        <div className="w1200">
          <div className="com_cmap_card_box" style={{ marginTop: 24, marginBottom: 24 }}>
            <div className="f18" style={{ marginBottom: 10 }}>
              打卡营习题批阅
            </div>
            <Tabs
              defaultActiveKey="1"
              destroyInactiveTabPane
              items={[
                {
                  label: `待批阅 ${markingNum}`,
                  key: '1',
                  children: <MarkingTable review={true} setMarkingNum={setMarkingNum} />,
                },
                {
                  label: '已批阅',
                  key: '2',
                  children: <MarkingTable review={false} />,
                },
              ]}
            />
          </div>
        </div>
      )}
    </>
  );
}
